export const TEXT_EDITOR_ES = {
  es: {
    richtexteditor: {
      alignments: "Alineaciones",
      justifyLeft: "Alinear a la izquierda",
      justifyCenter: "Alinear al centro",
      justifyRight: "Alinear a la derecha",
      justifyFull: "Alinear Justificar",
      fontName: "Nombre de la fuente",
      fontSize: "Tamaño de fuente",
      fontColor: "Color de fuente",
      backgroundColor: "Color de fondo",
      bold: "Negrita",
      italic: "Itálica",
      underline: "Subrayado",
      strikethrough: "Tachado",
      clearFormat: "Borrar formato",
      clearAll: "Limpiar todo",
      cut: "Cortar",
      copy: "Copiar",
      paste: "Pegar",
      unorderedList: "Lista con viñetas",
      orderedList: "Lista numerada",
      indent: "Aumentar sangría",
      outdent: "Disminuir sangría",
      undo: "Deshacer",
      redo: "Rehacer",
      superscript: "Superíndice",
      subscript: "Subíndice",
      createLink: "Insertar hipervínculo",
      openLink: "Enlace abierto",
      editLink: "Editar enlace",
      removeLink: "Remover enlace",
      image: "Insertar imagen",
      replace: "Reemplazar",
      align: "Alinear",
      caption: "Captura de imagen",
      remove: "Eliminar",
      insertLink: "Insertar el link",
      display: "Monitor",
      altText: "Texto alternativo",
      dimension: "Cambiar tamaño",
      fullscreen: "Maximizar",
      maximize: "Maximizar",
      minimize: "Minimizar",
      lowerCase: "Minúscula",
      upperCase: "Mayúscula",
      print: "Impresión",
      formats: "Formato",
      sourcecode: "Vista de código",
      preview: "Avance",
      viewside: "ViewSide",
      insertCode: "Insertar codigo",
      linkText: "Mostrar texto",
      linkTooltipLabel: "Título",
      linkWebUrl: "Dirección web",
      linkTitle: "Insertar título",
      linkurl: "http://example.com",
      linkOpenInNewWindow: "Abrir enlace en una nueva ventana",
      linkHeader: "Insertar enlace",
      dialogInsert: "Aceptar",
      dialogCancel: "Cancelar",
      dialogUpdate: "Actualizar",
      imageHeader: "Añadir imagen",
      imageLinkHeader: "También puede proporcionar un enlace desde la web",
      mdimageLink: "Proporcione una URL para su imagen",
      imageUploadMessage: "Arrastra aquí tus imágenes o ",
      imageDeviceUploadMessage: "Haga clic aquí para subir",
      imageAlternateText: "Texto alternativo",
      alternateHeader: "Texto alternativo",
      browse: "explora tu dispositivo",
      imageUrl: "http://example.com/image.png",
      imageCaption: "Subtítulo",
      imageSizeHeader: "Tamaño de la imagen",
      imageHeight: "Altura",
      imageWidth: "Anchura",
      textPlaceholder: "Insertar texto",
      inserttablebtn: "Insertar tabla",
      tabledialogHeader: "Insertar tabla",
      tableWidth: "Anchura",
      cellpadding: "Padding",
      cellspacing: "Espaciado",
      columns: "Número de columnas",
      rows: "Número de filas",
      tableRows: "Filas de mesa",
      tableColumns: "Columnas de tabla",
      tableCellHorizontalAlign: "Alineación horizontal de celda de tabla",
      tableCellVerticalAlign: "Alineación vertical de celda de tabla",
      createTable: "Crear tabla",
      removeTable: "Eliminar tabla",
      tableHeader: "Encabezado de tabla",
      tableRemove: "Eliminar tabla",
      tableCellBackground: "Fondo de celda de tabla",
      tableEditProperties: "Propiedades de edición de tabla",
      styles: "Estilos",
      insertColumnLeft: "Insertar columna a la izquierda",
      insertColumnRight: "Insertar columna a la derecha",
      deleteColumn: "Eliminar columna",
      insertRowBefore: "Insertar fila antes",
      insertRowAfter: "Insertar fila después",
      deleteRow: "Borrar fila",
      tableEditHeader: "Editar cabecera",
      TableHeadingText: "Texto cabecera",
      TableColText: "Columna",
      imageInsertLinkHeader: "Insertar el link",
      editImageHeader: "Editar imagen",
      alignmentsDropDownLeft: "Alinear a la izquierda",
      alignmentsDropDownCenter: "Alinear al centro",
      alignmentsDropDownRight: "Alinear a la derecha",
      alignmentsDropDownJustify: "Alinear Justificar",
      imageDisplayDropDownInline: "En línea",
      imageDisplayDropDownBreak: "Descanso",
      tableInsertRowDropDownBefore: "Insertar fila antes",
      tableInsertRowDropDownAfter: "Insertar fila después de",
      tableInsertRowDropDownDelete: "Borrar fila",
      tableInsertColumnDropDownLeft: "Insertar columna a la izquierda",
      tableInsertColumnDropDownRight: "Insertar columna a la derecha",
      tableInsertColumnDropDownDelete: "Eliminar columna",
      tableVerticalAlignDropDownTop: "Alinear la parte superior",
      tableVerticalAlignDropDownMiddle: "Alinear Medio",
      tableVerticalAlignDropDownBottom: "Alinear la parte inferior",
      tableStylesDropDownDashedBorder: "Fronteras discontinuas",
      tableStylesDropDownAlternateRows: "Filas Alternas",
      pasteFormat: "Pegar formato",
      pasteFormatContent: "Copiar formato",
      plainText: "Texto sin formato",
      cleanFormat: "Limpiar",
      keepFormat: "Mantener"
    }
  }
};

export const FORMAT = {
  default: 'Párrafo',
  width: 'auto',
  types: [
    { text: 'Párrafo', value: 'p' },
    { text: 'Código', value: 'pre' },
    { text: 'Citación', value: 'blockquote' },
    { text: 'Encabezado 1', value: 'h1' },
    { text: 'Encabezado 2', value: 'h2' },
    { text: 'Encabezado 3', value: 'h3' },
    { text: 'Encabezado 4', value: 'h4' },
    { text: 'Encabezado 5', value: 'h5' },
    { text: 'Encabezado 6', value: 'h6' }
  ]
};

export const FONT_SIZES = {
    default: '10pt',
    width: '30px',
    items: [
    { text: '8 pt', value: '8pt' },
    { text: '10 pt', value: '10pt' },
    { text: '12 pt', value: '12pt' },
    { text: '14 pt', value: '14pt' },
    { text: '18 pt', value: '18pt' },
    { text: '24 pt', value: '24pt' },
    { text: '36 pt', value: '36pt' }
    ]
};
